<div class="container-fluid">
    <div class="row mt-3 mb-3">
        <div class="col">
            <div class="card">
                <form [formGroup]="clientFormGroup" (ngSubmit)="onClientFormSubmit()">
                    <div class="card-header">
                        Client
                    </div>
                    <div class="card-body">
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">Title</label>
                            </dt>
                            <dd class="col-sm-3">
                                <select class="form-control form-control-sm" formControlName="title">
                                    <option *ngFor="let title of clientTitleArray" [value]="title.value">
                                        {{title.label}}</option>
                                </select>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">first name *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm"
                                    [ngClass]="{'is-invalid': clientErrorArray['firstName']}"
                                    formControlName="firstName" />
                                <div class="invalid-feedback" *ngIf="clientErrorArray['firstName']">
                                    {{clientErrorArray['firstName']}}
                                </div>
                            </dd>
                            <dt class="col-sm-2 text-right align-middle">
                                <label class="control-label col-form-label-sm">last name *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm"
                                    [ngClass]="{'is-invalid': clientErrorArray['lastName']}"
                                    formControlName="lastName" />
                                <div class="invalid-feedback" *ngIf="clientErrorArray['lastName']">
                                    {{clientErrorArray['lastName']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">first email *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm"
                                    (ngModelChange)="clientFormGroup.get('username').setValue(clientFormGroup.get('firstEmail').value)"
                                    [ngClass]="{'is-invalid': clientErrorArray['firstEmail']}"
                                    formControlName="firstEmail" />
                                <div class="invalid-feedback" *ngIf="clientErrorArray['firstEmail']">
                                    {{clientErrorArray['firstEmail']}}
                                </div>
                            </dd>
                            <dt class="col-sm-2 text-right align-middle">
                                <label class="control-label col-form-label-sm">second email</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm"
                                    [ngClass]="{'is-invalid': clientErrorArray['secondEmail']}"
                                    formControlName="secondEmail" />
                                <div class="invalid-feedback" *ngIf="clientErrorArray['secondEmail']">
                                    {{clientErrorArray['secondEmail']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">first phone</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm" formControlName="firstPhone" />
                            </dd>
                            <dt class="col-sm-2 text-right align-middle">
                                <label class="control-label col-form-label-sm">second phone</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm"
                                    formControlName="secondPhone" />
                            </dd>
                        </dl>
                        <hr />
                        <!-- <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">username</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm" formControlName="username"
                                    readonly="readonly" />
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">password</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm" formControlName="newPassword"
                                    disabled="disabled" />
                            </dd>
                            <dt class="col-sm-2 text-right align-middle">
                                <label class="control-label col-form-label-sm">repeat password</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm"
                                    formControlName="repeatPassword" disabled="disabled" />
                            </dd>
                        </dl>
                        <hr /> -->
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">company</label>
                            </dt>
                            <dd class="col-sm-3">
                                <select class="form-control form-control-sm" formControlName="companyAction"
                                    (ngModelChange)="onClientCompanyActionChange()">
                                    <option *ngFor="let action of clientCompanyActionArray" [value]="action.value">
                                        {{action.label}}
                                    </option>
                                </select>
                            </dd>
                            <dd class="col-sm-5" *ngIf="showCompanySearch">
                                <app-company-select-modal (companySelected)="onCompanySelectedEvent($event)"
                                    [showLabel]="false" [companyObject]="company">
                                </app-company-select-modal>
                            </dd>
                        </dl>
                        <hr />
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">status</label>
                            </dt>
                            <dd class="col-sm-3">
                                <select class="form-control form-control-sm" formControlName="status">
                                    <option *ngFor="let status of clientStatusArray" [value]="status.value">
                                        {{status.label}}</option>
                                </select>
                            </dd>
                            <dt class="col-sm-2 text-right align-middle">
                                <label class="control-label col-form-label-sm">language *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <select class="form-control form-control-sm" formControlName="language"
                                    [ngClass]="{'is-invalid': clientErrorArray['language']}">
                                    <option *ngFor="let language of clientLanguageArray" [value]="language.value">
                                        {{language.label}}
                                    </option>
                                </select>
                                <div class="invalid-feedback" *ngIf="clientErrorArray['language']">
                                    {{clientErrorArray['language']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                          <dt class="col-sm-3 text-right align-middle">
                            <label class="control-label col-form-label-sm">Referral</label>
                          </dt>
                          <dd class="col-sm-3">
                            <input type="input" class="form-control form-control-sm"
                                [attr.disabled]="true" *ngIf="surveyAnswer?.survey.id < 7"
                                formControlName="survey" [value]="surveys[surveyAnswer?.survey.id-1]?.nameEn" />
                            <input type="input" class="form-control form-control-sm"
                                [attr.disabled]="true" *ngIf="surveyAnswer?.survey.id === 7"
                                formControlName="survey" [value]="surveyAnswer?.description" />

                          </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle"></dt>
                            <dd class="col-sm-3">
                                <div class="form-group form-check m-0">
                                    <input type="checkbox" class="form-check-input" name="newsletter" id="newsletter"
                                        formControlName="newsletter" />
                                    <label class="form-check-label" for="newsletter"
                                        style="margin-top: 3px;">newsletter</label>
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">Notes</label>
                            </dt>
                            <dd class="col-sm-8">
                                <textarea class="form-control form-control-sm" formControlName="notes"
                                    rows="10"></textarea>
                            </dd>
                        </dl>
                    </div>
                    <div [class]="surveyGroupClass" *ngIf="method === 'create' || method === 'duplicate'">
                      <div class="survey-title col-12"
                        style="margin-top: 15px; padding:5px 0; text-align: center; background-color: #eff1f2; text-transform: uppercase; font-weight: bold;">
                        WIE SIND SIE AUF FAMULUS AUFMERKSAM GEWORDEN?
                      </div>
                      <div class="survey-content col-12"
                        style="margin-bottom: 15px; padding: 5px 50px;border:2px solid #eff1f2;">
                        <div class="row" style="padding:20px;">
                          <div class="col-12 col-md-6" style="padding: 5px 0;" *ngFor="let survey of surveys">
                            <input
                              class="form-check-input"
                              type="radio" name="survey" id="survey"
                              formControlName="survey" [value]="survey.id"
                              ngDefaultControl>
                            <label class="control-label" for="survey" style="margin-top: 3px;">
                                {{survey.name}}
                            </label>
                            <input type="text" maxlength="150" class="form-check-input" name="surveyDescription"  id="surveyDescription" formControlName="surveyDescription"
                              *ngIf="survey.id === 7"
                              style="margin: 0 10px; width:300px; border:2px solid #E0E0E0; display: inline-block;">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-footer">
                        <a class="btn btn-default btn-sm" href="/clients">
                            <i class="fa fa-times"></i> <br /> Cancel
                        </a>
                        <button class="btn btn-primary btn-sm float-right" type="submit">
                            <i class="fa fa-save"></i> <br />
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <div class="col">
            <div class="card" *ngIf="showCompanyForm">
                <form [formGroup]="companyFormGroup">
                    <div class="card-header">
                        Company
                    </div>
                    <div class="card-body">
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">Company Name *</label>
                            </dt>
                            <dd class="col-sm-8">
                                <input type="input" class="form-control form-control-sm"
                                    [ngClass]="{'is-invalid': companyErrorArray['name']}" formControlName="name" />
                                <div class="invalid-feedback" *ngIf=" companyErrorArray['name']">
                                    {{companyErrorArray['name']}}
                                </div>
                            </dd>
                        </dl>
                        <hr />
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">first email *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm"
                                    [ngClass]="{'is-invalid':  companyErrorArray['firstEmail']}"
                                    formControlName="firstEmail" />
                                <div class="invalid-feedback" *ngIf=" companyErrorArray['firstEmail']">
                                    {{ companyErrorArray['firstEmail']}}
                                </div>
                            </dd>
                            <dt class="col-sm-2 text-right align-middle">
                                <label class="control-label col-form-label-sm">second email</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm"
                                [ngClass]="{'is-invalid':  companyErrorArray['secondEmail']}"
                                    formControlName="secondEmail" />
                                <div class="invalid-feedback" *ngIf=" companyErrorArray['secondEmail']">
                                    {{ companyErrorArray['secondEmail']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">first phone</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm" formControlName="firstPhone" />
                            </dd>
                            <dt class="col-sm-2 text-right align-middle">
                                <label class="control-label col-form-label-sm">second phone</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm"
                                    formControlName="secondPhone" />
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">vat</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm" formControlName="vat" />
                            </dd>
                            <dt class="col-sm-2 text-right align-middle">
                                <label class="control-label col-form-label-sm">fiscal code</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm" formControlName="fiscalCode" />
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">pec email</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm" formControlName="pecEmail" />
                            </dd>
                            <dt class="col-sm-2 text-right align-middle">
                                <label class="control-label col-form-label-sm">isd number</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm" formControlName="isdNumber" />
                            </dd>
                        </dl>
                        <hr />
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">address</label>
                            </dt>
                            <dd class="col-sm-8">
                                <input type="input" class="form-control form-control-sm" formControlName="address" />
                            </dd>
                        </dl>
                        <dl class="row" style="justify-content: center;">
                          <app-select-location-group
                            class="col-sm-8"
                            [initialVillage]="chosenVillage"
                            [initialCountry]="chosenCountry"
                            (onCountryChosen)="chosenCountry = $event"
                            (onVillageChosen)="chosenVillage = $event">

                          </app-select-location-group>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">postal code</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm" formControlName="postalCode" />
                            </dd>
                        </dl>
                        <hr />
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">status</label>
                            </dt>
                            <dd class="col-sm-8">
                                <select class="form-control form-control-sm" formControlName="status">
                                    <option *ngFor="let status of companyStatusArray" [value]="status.value">
                                        {{status.label}}</option>
                                </select>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">Notes</label>
                            </dt>
                            <dd class="col-sm-8">
                                <textarea class="form-control form-control-sm" formControlName="notes"
                                    rows="10"></textarea>
                            </dd>
                        </dl>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
